enum LotStatuses {
  NONE = "None",
  PREPARED = "Prepared",
  LIVE = "Live",
  ENDED = "Ended"
}

export default LotStatuses;
